import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";
import { type UserResult } from "../../api/generated/data-contracts";

export interface AuthState {
  value: string;
  currentUser: UserResult | null;
}

const initialState: AuthState = {
  value: "",
  currentUser: null
};

export const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    login: (state, action: PayloadAction<AuthState>) => {
      state.value = action.payload.value;
      state.currentUser = action.payload.currentUser;
    },
    logout: (state) => {
      state.value = "";
      state.currentUser = null;
    }
  }
});

export const { login, logout } = authSlice.actions;

export const authReducer = authSlice.reducer;
